<ul class="dynamic-entity-list__items">
	@if (items().length > 0) {
		@for (item of items(); track item.id) {
			<li class="dynamic-entity-list__item">
				<span class="dynamic-entity-list__item-name">
					{{ item.name }}
				</span>
				<button
					type="button"
					tuiIconButton
					size="xs"
					appearance="ghost"
					(click)="onRemove(item)"
				>
					<tui-icon icon="@tui.x" />
				</button>
			</li>
		}
	} @else {
		<div class="dynamic-entity-list__empty">
			@if (emptyMessage(); as message) {
				<p class="dynamic-entity-list__empty-message">
					{{ message }}
				</p>
			}
		</div>
	}
</ul>

<div class="dynamic-entity-list__actions">
	<button
		type="button"
		tuiButton
		size="s"
		appearance="outline"
		(click)="onAdd()"
		iconStart="@tui.plus"
	>
		{{ addButtonLabel() | transloco }}
	</button>
</div>
